import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',
        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },
        '& .hero-shaped__image': {
          width: '60vw',
          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
      '& .hero-shaped__right-side': {
        '& .section-header__title': {
          fontFamily: 'Poppins, sans-serif',
          fontWeight: '400 !important',
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.glowdentalny-container': {
    /* General Styles */
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: palette.primary.light,
    },
    '& .MuiSwitch-track': {
      border: `1px solid ${palette.primary.main}`,
    },
    '& .MuiSwitch-thumb': {
      background: palette.primary.main,
    },

    '& .normal-text': {
      fontWeight: 300,
    },
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        background: palette.background.header,
        color: palette.text.highlight,
        marginTop: 88,
        '& h1,& h2,& h3,& h4,& p': {
          color: palette.text.highlight,
        },
      },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      '& .hero-background': {
        objectFit: 'cover',
        background: palette.background.fill,
        '@media screen and (max-width: 900px)': {
          height: '300px',
        },
        '@media screen and (min-width: 1300px)': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '700px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
        '@media(max-width: 900px) and (min-width: 600px)': {
          padding: '20px 20px',
          background: palette.background.discount,
        },
      },
      '& .home-hero-title': {
        position: 'relative',
        fontSize: 0,
        '&::before': {
          content: '"Glow Dental"',
          fontFamily: 'Brittany Signature, cursive !important',
          fontSize: 120,
          fontWeight: '400 !important',
          lineHeight: '120px',
          color: `${palette.text.highlight} !important`,
          letterSpacing: '0px',
          display: 'block',
          marginBottom: 24,
          textShadow: '0 0 8px rgba(255, 255, 255, 0.8)',
          '@media(max-width: 1200px) and (min-width: 600px)': {
            fontSize: '80px !important',
          },
        },
        '&::after': {
          content: '"memberships for affordable care"',
          fontFamily: 'Poppins, sans-serif !important',
          display: 'block',
          fontSize: 72,
          fontWeight: '300 !important',
          lineHeight: '64px',
          letterSpacing: '0px',
          color: `${palette.text.brand} !important`,
          '@media(max-width: 1200px) and (min-width: 600px)': {
            fontSize: '56px !important',
          },
        },
      },
      '& .home-hero-subtitle': {
        fontWeight: '400 !important',
        fontSize: 22,
        lineHeight: '30px',
        letterSpacing: '-0.96px',
        maxWidth: 614,
        color: palette.text.primary,
      },
      '@media screen and (max-width: 600px)': {
        '& .hero-section': {
          padding: '20px 20px',
          background: palette.background.discount,
        },
        '& .home-hero-title': {
          position: 'relative',
          fontSize: 0,
          '&::before': {
            content: '"Glow Dental"',
            fontFamily: 'Brittany Signature, cursive !important',
            fontSize: '60px !important',
            fontWeight: '400 !important',
            lineHeight: '70px !important',
            color: `${palette.text.highlight} !important`,
            letterSpacing: '0px',
            display: 'block',
            marginBottom: 24,
            textShadow: '0 0 8px rgba(255, 255, 255, 0.8)',
          },
          '&::after': {
            content: '"memberships for affordable care"',
            fontFamily: 'Poppins, sans-serif !important',
            display: 'block',
            fontSize: '40px !important',
            fontWeight: '400 !important',
            lineHeight: '40px !important',
            letterSpacing: '0px',
            color: `${palette.text.brand} !important`,
          },
        },
        '& .home-hero-subtitle': {
          fontSize: 20,
          fontFamily: 'Poppins, sans-serif',
          maxWidth: 550,
        },
      },
      '@media screen and (min-width: 900px) and (max-width: 1200px)': {
        '& .hero-section': {
          padding: '20px 20px',
          background: palette.background.discount,
          maxWidth: '2000px',
        },
      },
      '& .MuiButton-outlinedSecondary': {
        color: palette.text.primary,
        borderColor: palette.primary.main,
        backgroundColor: palette.secondary.main,
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      padding: '60px 0px',
      backgroundColor: palette.surface.light,
      '& .section-alternate__content': {
        padding: '48px 16px',
        '& .section-header__title-wrapper': {
          height: '100px',
        },
        '& .section-header__title': {
          // CSS-only solution for split fonts
          position: 'relative',
          fontSize: 0, // Hide original text
          '&::before': {
            content: '"Benefits"',
            fontFamily: 'Brittany Signature, cursive !important',
            fontSize: 96,
            fontWeight: '400 !important',
            lineHeight: '48px',
            letterSpacing: '-3.84px',
            color: `${palette.surface.alternate} !important`,
            '@media(max-width: 900px) and (min-width: 600px)': {
              fontSize: '54px !important',
            },
            '@media(max-width: 600px)': {
              fontSize: '48px !important',
            },
          },
          '&::after': {
            content: '" OF PLAN"',
            fontFamily: 'Poppins, sans-serif !important',
            fontSize: 56,
            fontWeight: '400 !important',
            lineHeight: '48px',
            letterSpacing: '-2.24px',
            color: `${palette.text.primary} !important`,
            '@media(max-width: 900px) and (min-width: 600px)': {
              fontSize: '40px !important',
            },
            '@media(max-width: 600px)': {
              fontSize: '40px !important',
            },
          },
        },

        '@media (min-width: 600px)': {
          padding: '48px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '& .definition-service-tile': {
          height: '100%',
          '@media (min-width: 600px)': {
            padding: '10px 24px',
          },
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
        '@media (max-width: 850px)': {
          display: 'grid !important',
          gridTemplateColumns: '1fr !important',
        },
      },
      '& .definition-services-grid .MuiGrid-item': {
        '@media (max-width: 850px)': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
      },
      '& .MuiCardContent-root': {
        padding: 32,
        borderRadius: 10,
        border: `1px solid ${palette.background.border}`,
        '@media (max-width: 600px)': {
          padding: '24px 24px',
        },
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 16,
        marginBottom: '0px !important',
      },
      '& .definition-service-title': {
        marginLeft: 16,
        fontWeight: '500 !important',
        fontSize: 24,
        letterSpacing: '-0.96px',
        lineHeight: '30px',
        color: palette.text.primary,
      },
      '& .definition-service-description': {
        marginBottom: 0,
        color: palette.text.secondary,
        fontSize: 18,
        lineHeight: '26px',
        fontWeight: '400 !important',
        letterSpacing: '-0.9px',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      fontFamily: 'Poppins, sans-serif',
      padding: '60px 0px',
      '& .section-alternate__content': {
        '@media(max-width: 600px)': {
          padding: '18px 24px',
        },
      },
      '& .subscription-bg': {
        height: '100%',
        background: `
        url('/images/home-images/pricing-pattern.webp') no-repeat,
        ${palette.surface.pricing}
      `,
      },
      '& .section-header': {
        gap: 24,
      },
      '& .section-header__title-wrapper': {
        height: '80px',
      },
      '& .section-header__title': {
        color: `${palette.text.highlight} !important`,
        '&.MuiTypography-root': {
          fontWeight: '300 !important',
        },
        '&[class*="jss"]': {
          fontWeight: '300 !important',
        },
        position: 'relative',
        fontSize: 0,
        '&::before': {
          content: '"Pricing"',
          fontFamily: 'Brittany Signature, cursive !important',
          fontSize: 96,
          fontWeight: '400 !important',
          lineHeight: '48px',
          letterSpacing: '-3.84px',
          color: `${palette.text.tertiary} !important`,
          '@media(max-width: 900px) and (min-width: 600px)': {
            fontSize: '54px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '48px !important',
          },
        },
        '&::after': {
          content: '" & BENEFITS"',
          fontFamily: 'Poppins, sans-serif !important',
          fontSize: 56,
          fontWeight: '400 !important',
          lineHeight: '48px',
          letterSpacing: '-2.24px',
          color: `${palette.text.highlight} !important`,
          '@media(max-width: 900px) and (min-width: 600px)': {
            fontSize: '40px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '36px !important',
          },
        },
      },
      '& .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
        {
          color: `${palette.text.highlight} !important`,
          fontSize: 22,
          lineHeight: '30px',
          letterSpacing: '-0.96px',
          fontWeight: '400 !important',
          '@media(max-width: 900px) and (min-width: 600px)': {
            fontSize: '22px !important',
            lineHeight: '30px !important',
            letterSpacing: '-0.88px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '18px !important',
            lineHeight: '26px !important',
            letterSpacing: '-0.72px !important',
          },
        },
      '& .section-header__subtitle-wrapper': {
        width: '713px',
      },
      '& .section-header__subtitle': {
        color: palette.text.primary,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '& .customcardTitle': {
            fontFamily: 'Brittany Signature, cursive !important',
            fontSize: 60,
            lineHeight: '80px',
            letterSpacing: '-2.88px',
            padding: '20px 0px',
            color: palette.text.brand,
            fontWeight: '400 !important',
            '@media(max-width: 600px)': {
              fontSize: '48px !important',
              lineHeight: '64px !important',
              letterSpacing: '-2.24px !important',
            },
          },
          '& .customSubscriberName': {
            fontSize: 16,
            lineHeight: '22px',
            letterSpacing: '-0.32px',
            color: palette.text.secondary,
            fontWeight: '400 !important',
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: '400 !important',
              fontSize: 22,
              lineHeight: '30px',
              letterSpacing: '-1.12px',
              color: palette.text.primary,
            },
            '& .cptCodes': {
              fontSize: 16,
              lineHeight: '22px',
              letterSpacing: '-0.32px',
              color: palette.text.secondary,
              fontWeight: '400 !important',
            },
          },
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-outlinedSecondary': {
            color: palette.text.primary,
            borderColor: palette.primary.main,
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 620,
            margin: '0px auto 32px',
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .summary-subtext': {
          color: palette.text.highlight,
        },
        '& .savings-summary-link': {
          color: palette.text.tertiary,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 40,
        fontSize: 48,
      },
      '& .howitworks-wrapper': {
        padding: 20,
        '& .section-header': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80px',
          '& .section-header__title': {
            position: 'relative',
            fontSize: 0, 
            '&::before': {
              content: '"HOW IT"',
              fontFamily: 'Poppins, sans-serif !important',
              fontSize: 56,
              fontWeight: '400 !important',
              lineHeight: '48px',
              letterSpacing: '-2.24px',
              color: `${palette.text.primary} !important`,
              '@media(max-width: 900px) and (min-width: 600px)': {
                fontSize: '40px !important',
              },
              '@media(max-width: 600px)': {
                fontSize: '40px !important',
              },
            },
            '&::after': {
              content: '" Works"',
              fontFamily: 'Brittany Signature, cursive !important',
              fontSize: 96,
              fontWeight: '400 !important',
              lineHeight: '48px',
              letterSpacing: '-3.2px',
              color: `${palette.surface.alternate} !important`,
              '@media(max-width: 900px) and (min-width: 600px)': {
                fontSize: '54px !important',
              },
              '@media(max-width: 600px)': {
                fontSize: '56px !important',
              },
            },
          },
        },
        '& .working-steps-container': {
          '& .cover-image-wrapper': {
            '& .how-it-works-image': {
              borderRadius: 8,
            },
          },
        },
        '& .step-subtitle-wrapper': {
          paddingRight: 0,
          '@media(max-width: 900px)': {
            paddingRight: '0px !important',
          },
        },
      },
      '& .howitworks-wrapper-left': {
        padding: 20,
        '@media screen and (max-width: 900px)': {
          padding: '5px',
        },
        '@media(min-width: 900px)': {
          paddingLeft: '100px',
        },
      },
      '& .makeStyles-root-54': {
        padding: 0,
      },
      '& .how-cover-image': {
        backgroundSize: 'cover',
      },
      '& .step-title': {
        color: palette.text.primary,
        fontSize: 24,
        fontWeight: '500 !important',
        letterSpacing: '-0.96px',
        lineHeight: '30px',
        '@media(max-width: 1200px)': {
          fontSize: '22px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.96px !important',
        },
      },
      '& .step-content': {
        color: palette.text.secondary,
        fontSize: 18,
        lineHeight: '26px',
        fontWeight: '400 !important',
        letterSpacing: '-0.9px',
      },
      '@media (max-width: 600px)': {
        paddingTop: '0px !important',
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        '& .section': {
          '& .section-header': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start !important',
            alignItems: 'center',
            padding: '0px 20px !important',
            '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
              {
                '& .hero-header-title': {
                  textAlign: 'left',
                  paddingLeft: '20px !important',
                  color: palette.text.tertiary,
                  fontWeight: '400 !important',
                  fontSize: '32px !important',
                  letterSpacing: '0px',
                  lineHeight: '32px',
                  '@media(max-width: 900px)': {
                    textAlign: 'center !important',
                  },
                },
                '& .hero-header-subtitle': {
                  marginLeft: '0px !important',
                  paddingLeft: '20px !important',
                  textAlign: 'left !important',
                  fontWeight: '400 !important',
                  fontSize: '18px !important',
                  lineHeight: '22px',
                  letterSpacing: '-0.72px',
                  '@media(max-width: 900px)': {
                    textAlign: 'center !important',
                  },
                },
              },
          },
          '& .header-container': {
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'flex-start',
            marginRight: '20px !important',
          },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          '@media screen and (max-width: 900px)': {
            '& .section-header': {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center !important',
              alignItems: 'center',
              '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
                {
                  '& .hero-header-title': {
                    textAlign: 'center',
                    paddingLeft: '50px !important',
                    color: palette.text.tertiary,
                    fontWeight: '400 !important',
                    fontSize: '24px !important',
                    letterSpacing: '0px',
                    lineHeight: '32px',
                  },
                  '& .hero-header-subtitle': {
                    marginLeft: '0px !important',
                    paddingLeft: '50px !important',
                    textAlign: 'center !important',
                    fontWeight: '400 !important',
                    fontSize: '16px !important',
                    lineHeight: '22px',
                    letterSpacing: '-0.72px',
                  },
                },
            },
            display: 'flex',
            flexDirection: 'column',
          },
        },
        '& .hero-header-title, .hero-header-subtitle': {
          margin: '0',
          maxWidth: 'unset',
          fontFamily: 'Poppins, sans-serif !important',
          fontWeight: '400 !important',
          letterSpacing: '-0.2px',
        },
        '& .header-container': {
          '@media(max-width: 900px)': {
            justifyContent: 'center !important',
            paddingLeft: '10px !important',
            paddingRight: '15px !important',
          },
          margin: '0',
        },
        '@media screen and (max-width: 900px)': {
          '& .section': {
            marginTop: '10px',
            padding: '64px 24px !important',
          },
        },
      },
      '& .savingsDataContainer': {
        '& .footer-bar': {
          backgroundColor: palette.background.footer,
        },
        '& .view-more-button': {
          backgroundColor: palette.primary.main,
          color: palette.text.highlight,
        },
      },
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
          textAlign: 'left',
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
          textAlign: 'left',
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-header': {
          color: palette.text.primary,
        },
        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },
      '& .savings-contact-card': {
        background: `${palette.surface.light} !important`,
        width: '100%',
        margin: 'unset',
        maxWidth: 'unset',
        padding: '0px 0px !important',
        '@media(max-width: 1200px) and (min-width: 600px)': {
          paddingLeft: '20px !important',
        },
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-title': {
          height: '80px',
          position: 'relative',
          fontSize: 0,
          '&::before': {
            content: '"STILL HAVE"',
            fontFamily: 'Poppins, sans-serif !important',
            fontSize: 48,
            fontWeight: '400 !important',
            color: `${palette.text.primary} !important`,
            '@media(max-width: 600px)': {
              paddingLeft: '20px !important',
              fontSize: '32px !important',
            },
            '@media(max-width: 900px) and (min-width: 600px)': {
              paddingLeft: '20px !important',
              fontSize: '40px !important',
            },
          },
          '&::after': {
            content: '" Questions?"',
            fontFamily: 'Brittany Signature, cursive !important',
            fontSize: 80,
            fontWeight: '400 !important',
            lineHeight: '48px',
            letterSpacing: '-3.2px',
            color: `${palette.surface.alternate} !important`,
            '@media(max-width: 600px)': {
              fontSize: '40px !important',
            },
            '@media(max-width: 900px) and (min-width: 600px)': {
              fontSize: '60px !important',
            },
          },
        },
        '& .contact-card-subtitle': {
          color: palette.text.secondary,
          fontSize: 20,
          fontWeight: 400,
          letterSpacing: '-0.02em',
          '@media(max-width: 900px)': {
            paddingLeft: '20px !important',
          },
        },
        '& .provider-contact-details': {
          fontFamily: 'Poppins, sans-serif',
          fontSize: 16,
          color: palette.text.secondary,
          fontWeight: 400,
        },
        '& .provider-contact-link': {
          fontFamily: 'Poppins, sans-serif',
          fontSize: 20,
          fontWeight: 500,
        },
      },
      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.surface.light,
      },
      '& .section-header__title': {
        // CSS-only solution for split fonts
        position: 'relative',
        textAlign: 'center',
        fontSize: 0, // Hide original text
        '&::before': {
          content: '"Questions?"',
          fontFamily: 'Brittany Signature, cursive !important',
          fontSize: 96,
          fontWeight: '400 !important',
          lineHeight: '48px',
          letterSpacing: '-3.84px',
          color: `${palette.surface.alternate} !important`,
          '@media(max-width: 1024px) and (min-width: 600px)': {
            fontSize: '54px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '48px !important',
          },
        },
        '&::after': {
          content: '" WE HAVE ANSWERS!"',
          fontFamily: 'Poppins, sans-serif !important',
          fontSize: 56,
          lineHeight: '48px',
          letterSpacing: '-2.24px',
          fontWeight: '400 !important',
          color: `${palette.text.primary} !important`,
          '@media(max-width: 1024px) and (min-width: 600px)': {
            fontSize: '40px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '36px !important',
          },
        },
      },
      '& .section-header__subtitle': {
        paddingTop: '20px',
        textAlign: 'center',
        color: palette.text.secondary,
        fontSize: 22,
        lineHeight: '30px',
        letterSpacing: '-0.96px',
        '@media(max-width: 1200px) and (min-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .hero-static-section-grid': {
        display: 'flex',
        flexDirection: 'column',
        '& .section-header': {
          textAlign: 'center',
        },
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.primary.main,
        borderColor: palette.surface.learnMore,
        color: palette.text.highlight,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Poppins, sans-serif !important',
        fontWeight: '400 !important',
        fontSize: '32px !important',
        letterSpacing: '0px',
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .faq-hero-internal': {
        '& .section-header': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start !important',
          alignItems: 'center',
          '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
            {
              '& .hero-header-title': {
                textAlign: 'left',
                paddingLeft: '20px !important',
                color: palette.text.tertiary,
                fontWeight: '400 !important',
                fontSize: '32px !important',
                letterSpacing: '0px',
                lineHeight: '32px',
                '@media(max-width: 900px)': {
                  textAlign: 'center !important',
                },
              },
              '& .hero-header-subtitle': {
                marginLeft: '0px !important',
                paddingLeft: '20px !important',
                textAlign: 'left !important',
                fontWeight: '400 !important',
                fontSize: '18px !important',
                lineHeight: '22px',
                letterSpacing: '-0.72px',
                '@media(max-width: 900px)': {
                  textAlign: 'center !important',
                },
              },
            },
        },
        '& .header-container': {
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'flex-start',
          marginRight: '20px !important',
        },
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        '@media screen and (max-width: 900px)': {
          '& .section-header': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center !important',
            alignItems: 'center',
            '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
              {
                '& .hero-header-title': {
                  textAlign: 'center',
                  paddingLeft: '50px !important',
                  color: palette.text.tertiary,
                  fontWeight: '400 !important',
                  fontSize: '24px !important',
                  letterSpacing: '0px',
                  lineHeight: '32px',
                },
                '& .hero-header-subtitle': {
                  marginLeft: '0px !important',
                  paddingLeft: '50px !important',
                  textAlign: 'center !important',
                  fontWeight: '400 !important',
                  fontSize: '16px !important',
                  lineHeight: '22px',
                  letterSpacing: '-0.72px',
                },
              },
          },
          display: 'flex',
          flexDirection: 'column',
        },
      },
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
        fontFamily: 'Poppins, sans-serif !important',
        fontWeight: '400 !important',
        letterSpacing: '-0.2px',
      },
      '& .header-container': {
        '@media(max-width: 900px)': {
          justifyContent: 'center !important',
          paddingLeft: '10px !important',
          paddingRight: '15px !important',
        },
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.surface.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingLeft: '30px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        height: '80px',
        position: 'relative',
        fontSize: 0,
        '&::before': {
          content: '"STILL HAVE"',
          fontFamily: 'Poppins, sans-serif !important',
          fontSize: 48,
          fontWeight: '400 !important',
          color: `${palette.text.primary} !important`,
          '@media(max-width: 600px)': {
            paddingLeft: '20px !important',
            fontSize: '32px !important',
          },
          '@media(max-width: 900px) and (min-width: 600px)': {
            paddingLeft: '20px !important',
            fontSize: '40px !important',
          },
        },
        '&::after': {
          content: '" Questions?"',
          fontFamily: 'Brittany Signature, cursive !important',
          fontSize: 80,
          fontWeight: '400 !important',
          lineHeight: '48px',
          letterSpacing: '-3.2px',
          color: `${palette.surface.alternate} !important`,
          '@media(max-width: 600px)': {
            fontSize: '40px !important',
          },
          '@media(max-width: 900px) and (min-width: 600px)': {
            fontSize: '60px !important',
          },
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.02em',
        '@media(max-width: 900px)': {
          paddingLeft: '20px !important',
        },
      },
      '& .provider-contact-details': {
        fontFamily: 'Poppins, sans-serif',
        fontSize: 16,
        color: palette.text.secondary,
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        fontFamily: 'Poppins, sans-serif',
        fontSize: 20,
        fontWeight: 500,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      // maxWidth: '898px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.text.primary,
        color: palette.text.primary,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.text.primary, // Common border color for all states

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        color: palette.text.primary, // Filled background
        '& .MuiSvgIcon-root': {
          color: palette.text.primary,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        color: palette.text.primary, // Filled background
        '& .MuiSvgIcon-root': {
          color: palette.text.primary,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        color: 'transparent', // Transparent background
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.primary, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: palette.text.primary,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },
    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      color: palette.text.highlight,
      '& a': {
        color: palette.text.highlight,
      },
    },
  },
};